// Viewport Scaler - モバイル対応のビューポートスケーリング

import type p5 from 'p5';
import { CONFIG } from '../config/game-config';

const CANVAS_WIDTH = CONFIG.layout.canvasWidth;  // 640
const CANVAS_HEIGHT = CONFIG.height;              // 700

let _scale = 1;

export function getViewportScale(): number {
    return _scale;
}

/**
 * スケール係数を計算（1.0を超えない）
 */
function calcScale(): number {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    return Math.min(vw / CANVAS_WIDTH, vh / CANVAS_HEIGHT, 1.0);
}

/**
 * DOM要素にスケールを適用
 *
 * CSS transformはレイアウトボックスのサイズを変えないため、
 * game-containerをabsolute配置し、wrapperのサイズのみが
 * レイアウトに影響するようにする。
 */
function applyScale(): void {
    _scale = calcScale();

    const container = document.getElementById('game-container');
    const wrapper = document.getElementById('game-wrapper');
    if (!container || !wrapper) {
        return;
    }

    container.style.transform = `scale(${_scale})`;

    wrapper.style.width = `${Math.floor(CANVAS_WIDTH * _scale)}px`;
    wrapper.style.height = `${Math.floor(CANVAS_HEIGHT * _scale)}px`;
}

/**
 * P5.jsのmouseX/mouseYをCSS transformスケーリングに合わせて補正する。
 *
 * CSS transform:scale(s) が親要素に適用されると、P5.jsが計算する
 * mouseX/mouseYは視覚上の座標になり、内部座標系とずれる。
 * rawValue / scale で内部座標に変換する。
 */
function overrideMouseCoords(p: p5): void {
    let _rawMouseX = 0;
    let _rawMouseY = 0;

    Object.defineProperty(p, 'mouseX', {
        get(): number {
            return _rawMouseX / _scale;
        },
        set(v: number) {
            _rawMouseX = v;
        },
        configurable: true
    });

    Object.defineProperty(p, 'mouseY', {
        get(): number {
            return _rawMouseY / _scale;
        },
        set(v: number) {
            _rawMouseY = v;
        },
        configurable: true
    });
}

/**
 * ビューポートスケーリングを初期化。
 * P5.jsキャンバス作成後に呼び出す。
 */
export function initViewportScaler(p: p5): void {
    applyScale();
    overrideMouseCoords(p);

    window.addEventListener('resize', applyScale);
    window.addEventListener('orientationchange', () => {
        setTimeout(applyScale, 100);
    });
}
